import { render } from "./ModalDeposit.vue?vue&type=template&id=3ed2fca4"
import script from "./ModalDeposit.vue?vue&type=script&lang=js"
export * from "./ModalDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__